import { render, staticRenderFns } from "./brandList.vue?vue&type=template&id=4a415260&"
import script from "./brandList.vue?vue&type=script&lang=js&"
export * from "./brandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports